import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { DEFAULT_LANGUAGE, getLanguage, setStoredLanguage } from "../utils/translate";

const LanguageContext = createContext({
  language: DEFAULT_LANGUAGE,
  setLanguage: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(getLanguage);

  const setLanguage = useCallback((lang) => {
    setLanguageState(setStoredLanguage(lang));
  }, []);

  const value = useMemo(() => ({ language, setLanguage }), [language, setLanguage]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
